import _ from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import SectionAncestry from 'components/_special/SectionAncestry'
import FaqBlock from 'components/FaqBlock'
import { GOODS_TYPES } from 'constants/sales'
import CartSaleWideContainer from 'containers/CartSaleWideContainer'
import DistributionBannerContainer from 'containers/DistributionBannerContainer'
import { LocalizationContext } from 'contexts/Localization'
import { ResizeContext } from 'contexts/Resize'
import { LastBlock } from 'styles/components/layout'

import DResultsFirst from './components/DResultsFirst'
import DResultsHealth from './components/DResultsHealth'
import DResultsNutrition from './components/DResultsNutrition'
import DResultsSports from './components/DResultsSports'
import DResultsTraits from './components/DResultsTraits'

const DnaResults = ({ texts, pathCdn, locale }) => {
  const secondBlock = React.useRef()
  const { mobile } = React.useContext(ResizeContext)
  const { specialDistribution } = React.useContext(LocalizationContext)

  return (
    <>
      <DResultsFirst data={texts.first} secondBlockRef={secondBlock} />

      {!specialDistribution && (
        <div ref={secondBlock} className="pt-4">
          <DResultsHealth data={texts.health} pathCdn={pathCdn} />
        </div>
      )}

      <div className="pt-6">
        {specialDistribution && <div ref={secondBlock} />}
        <DResultsNutrition data={texts.nutrition} pathCdn={pathCdn} />
      </div>
      {!_.isEmpty(texts.sports) && (
        <div className="pt-6">
          <DResultsSports data={texts.sports} pathCdn={pathCdn} />
        </div>
      )}
      <div className="pt-6">
        <SectionAncestry
          title={texts.ancestry.title}
          list={texts.ancestry.list}
        />
      </div>
      <div className="pt-6">
        <DResultsTraits data={texts.traits} pathCdn={pathCdn} />
      </div>

      <div className="pt-2 pt-md-4">
        <FaqBlock
          wrapperClassName="bg--gray--op-06 py-2 py-md-4"
          isMobile={mobile}
          items={texts.faq.list}
          title={texts.faq.title}
          locale={locale}
        />
      </div>

      <LastBlock>
        <CartSaleWideContainer
          className="pt-2 pt-md-4"
          productType={GOODS_TYPES.dna}
        />

        <DistributionBannerContainer />
      </LastBlock>
    </>
  )
}

DnaResults.propTypes = {
  locale: PropTypes.string.isRequired,
  pathCdn: PropTypes.string.isRequired,
  texts: PropTypes.object.isRequired,
}

export default DnaResults
